import { useCallback, useState } from "react";
import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import ApiBooking from "../types/ApiBooking";

type Output = ApiBooking[];

export interface BookingFilters {
    city?: string | string[]; // puede ser 1 o varios ciudades
}

export function useCityMeSearchData() {
    const client = useAPIClient();

    const [data, setData] = useState<Output>([]);
    const [loading, setLoading] = useState(false);

    const fetchData = useCallback((filters: BookingFilters) => {
        setLoading(true);

        return client.get<Output>(`cities`, {
            id: filters.city,
            itemsPerPage: 1000,
            "order[id]": "DESC",
        }).then((data) => {
            setData(data);
            setLoading(false);
        }).catch(() => {
            setData([]);
            setLoading(false);
        });
    }, [client]);

    return { data, loading, fetchData };
}
